import React from "react";
import { Header } from "../header/header";
import { IconButton } from "../icon-button";
import { useLabels } from "../../hooks/useLabels";
import { labels } from "./labels";

const HeaderLeft = ({ onClose }: { onClose: () => void }) => (
	<div className="header__left__wrapper">
		<div>
			<IconButton
				className="spread-overview-screen__header__back"
				iconName="angle-left-slim"
				onClick={onClose}
			/>
		</div>
	</div>
);

const HeaderRight = ({
	isDeleteEnabled,
	onDelete,
}: {
	isDeleteEnabled: boolean;
	onDelete: () => void;
}) => {
	const [[removeLabel]] = useLabels([labels.remove]);
	return (
		<IconButton
			className="spread-overview-screen__header__delete"
			title={removeLabel}
			iconName="bin"
			disabled={!isDeleteEnabled}
			onClick={onDelete}
		/>
	);
};

export const SpreadOverviewHeader = ({
	onClose,
	isDeleteEnabled,
	onDelete,
}: {
	onClose: () => void;
	isDeleteEnabled: boolean;
	onDelete: () => void;
}) => {
	return (
		<Header
			left={<HeaderLeft onClose={onClose} />}
			right={<HeaderRight isDeleteEnabled={isDeleteEnabled} onDelete={onDelete} />}
		/>
	);
};
